import { AccountTypes } from "./AccountTypes";

export class AuthenticationResult {
    public token: string;
    public accountId: string;
    public accountType: AccountTypes;
    public newSignup: boolean;
    public userName: string;
}
